import MicroModal from 'micromodal';

export namespace Helpers {
    export const CloseOnOutsideClick = (el, func) => {
        let targetEl = el;

        document.addEventListener('click', function (event) {
            let isClickInside = targetEl.contains(event.target);

            if (!isClickInside) {
                func();
            }
        });
    }

    /**
     * Set up the pagination functionality when user changes page size dropdown
     */
    export const SetupPagination = () => {
        let pageSize = document.getElementById('Criteria_PageSize') as HTMLInputElement;
        let page = document.getElementById('Criteria_Page') as HTMLInputElement;

        if (pageSize) {
            // Get parent form
            let form = pageSize.closest('form') as HTMLFormElement;

            pageSize.addEventListener('change', () => {
                // Set page back to first page
                if (page) {
                    page.value = '1';
                }
                form.submit();
            });
        }

        // Set up pagination controls
        if (page) {
            // Get parent form
            let form = page.closest('form') as HTMLFormElement;

            document.querySelectorAll('.js-page').forEach(e => {
                let pageControl = e as HTMLElement;

                pageControl.addEventListener('click', () => {
                    page.value = pageControl.dataset.page;
                    form.submit();
                });
            });
        }
    };

    /**
     * Set up column sorting
     */
    export const SetupSorting = () => {
        let sortBy = document.getElementById('Criteria_SortBy') as HTMLInputElement;
        let sortOrder = document.getElementById('Criteria_SortOrder') as HTMLInputElement;
        let page = document.getElementById('Criteria_Page') as HTMLInputElement;
        let form: HTMLFormElement = null;

        if (sortBy) {
            form = sortBy.closest('form');
        }

        document.querySelectorAll('.js-data-table th.sort').forEach(item => {
            let sortableColumn = item as HTMLElement;

            sortableColumn.addEventListener('click', () => {
                sortBy.value = sortableColumn.dataset.sortColumn;

                if (sortOrder) {
                    sortOrder.value = sortableColumn.dataset.sortOrder;
                }

                if (page) {
                    page.value = '1';
                }

                form.submit();
            });
        });
    };

    /**
     * Set up sorting dropdown
     */
    export const SetupSortingDropdown = () => {
        let sortBy = document.getElementById('Criteria_SortBy') as HTMLInputElement;
        let sortOrder = document.getElementById('Criteria_SortOrder') as HTMLInputElement;
        let page = document.getElementById('Criteria_Page') as HTMLInputElement;

        if (sortBy) {
            let form = sortBy.closest('form') as HTMLFormElement;
            sortBy.addEventListener('change', () => {
                if (page) {
                    page.value = '1';
                }

                form.submit();
            });
        }

        if (sortOrder) {
            let form = sortOrder.closest('form') as HTMLFormElement;
            sortOrder.addEventListener('change', () => {
                if (page) {
                    page.value = '1';
                }

                form.submit();
            });
        }
    };

    /**
     * Set up click event that opens modal to get details of clicked element in row
     */
    export const SetupDetailsModal = () => {
        let modalContent = document.getElementById('modal-details-content');

        document.querySelectorAll('.js-details-modal').forEach(item => {
            item.addEventListener('click', event => {
                let link = event.target as HTMLAnchorElement;
                event.preventDefault();

                fetch(link.href)
                    .then(response => response.text())
                    .then(data => {
                        modalContent.innerHTML = data;

                        // Open modal
                        MicroModal.show('modal-details', {
                            onShow: modal => {
                                // Set up click event for export
                                document.querySelector('.js-export-modal').addEventListener('click', event => exportClickEvent(event, 'frmReportModal'));
                            }
                        });
                    });
            });
        });
    };

    /**
     * Set up CSV export click events
     */
    export const SetupExport = () => {
        document.querySelectorAll('.js-export').forEach(item => {
            item.addEventListener('click', event => exportClickEvent(event, 'frmReport'));
        });
    };

    /**
     * Toggle scroll class
     */
    export const ToggleScroll = () => {
        document.getElementsByTagName('html')[0].classList.toggle('no-scroll');
    };

    /**
     * Delete modal configuration
     */
    export const SetupDeleteModal = () => {
        document.querySelectorAll('.js-modal-delete').forEach(modalLink => {
            modalLink.addEventListener('click', (e) => {
                let modalId = modalLink.getAttribute('data-micromodal-trigger');
                e.preventDefault();

                MicroModal.show(modalId, {
                    onShow: modal => {
                        let buttonConfirm = document.getElementById('js-confirm-delete') as HTMLButtonElement;
                        let videoName = document.getElementById('js-delete-name') as HTMLElement;
                        let videoId = document.getElementById('js-delete-id') as HTMLInputElement;

                        if (videoId && buttonConfirm) {
                            videoName.innerHTML = modalLink.getAttribute('data-name');
                            videoId.value = modalLink.getAttribute('data-id');

                            buttonConfirm.addEventListener('click', () => {
                                let formDelete = document.getElementById('frmDelete') as HTMLFormElement;

                                if (formDelete) {
                                    formDelete.submit();
                                }
                            });
                        }

                        Helpers.ToggleScroll();
                    },
                    onClose: modal => Helpers.ToggleScroll(),
                });
            });
        });
    };

    /**
     * Formats date to mm/dd/yyyy
     * @param date Date/Time
     * @returns 
     */
    export const FormatDate = (date: Date) => {
        let year = date.getFullYear();
        let month = (1 + date.getMonth()).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');

        return month + '/' + day + '/' + year;
    };

    /**
     * Handles click event for export link, which sets the action of parent form
     * to the href of current event. The parent form's action is reset back to
     * original value from data attribute after submit.
     * @param event Click event
     * @param formId Id of parent form
     */
    let exportClickEvent = (event: Event, formId: string) => {
        let link = event.target as HTMLAnchorElement;
        let form = document.getElementById(formId) as HTMLFormElement;

        event.preventDefault();

        // Override the action of the form and submit to export URL
        form.action = link.href;
        form.submit();

        // Restore the action of form
        form.action = form.dataset.action;
    };
}
